module.exports = __webpack_public_path__ + "static/media/house.284b107f.svg";